import { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import News from 'components/News';
import DownloadDocument from 'components/DownloadDocument';
import Loading from 'components/loading';
import DownloadService from 'services/download';
import ShortcutSection from './homeShortcuts';

const Home = ({ isMobile, defaultSkip, queryString }) => {
  const [repConsultati, setRepConsultati] = useState([]);
  const [repEvidenziati, setRepEvidenziati] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (defaultSkip) defaultSkip(false);
    if (queryString) queryString('');
    document.title = 'Home - SITUAS';
    getRepConsultati();
  }, []);

  const getRepConsultati = async () => {
    try {
      Promise.all([
        DownloadService.getReportConsultati(),
        DownloadService.getReportEvidenza()
      ]).then((onfulfilled) => {
        setLoading(false);
        setRepConsultati(onfulfilled[0].data?.items ? onfulfilled[0].data.items : []);
        setRepEvidenziati(onfulfilled[1].data?.items ? onfulfilled[1].data.items : []);
      });
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loading fullPage />}
      <ShortcutSection></ShortcutSection>
      <div className="row" gutter={10 /* 4 */} style={{ rowGap: '4px' }}>
        <aside id="aside-content" className="col-12 col-md-4 pt-3 pb-5" aria-label="Aggiornamenti">
          <div className="position-relative mb-4">
              <News isMobile={isMobile} />
          </div>
        </aside>
        <main id="main-content" className={`col-12 col-md-8 bs-docs-section clearfix pt-3 pb-5`}>
            <h2 className="docs-title mb-3">Link</h2>
            <Row gutter={6}>
              <Col xs={12} className="d-flex flex-column" style={{ gap: '8px', paddingRight:'6px' }}>
                <h3 className="document-category m-0">
                  In evidenza
                </h3>
                {repEvidenziati.map((report, index) => (
                  <DownloadDocument
                    disabled={report.rule_showhide !== 'ABILITATO'}
                    key={report.id_funzione}
                    title={report.titolo_report}
                    periodoString={report.periodo_dati}
                    descrizione={report.descrizione_report}
                    idFunzione={report.id_funzione}
                    pData={report.pdata}
                    metadati={report}
                    level={3}
                    tabIndex={0}
                    urlPath="in-evidenza"
                  />
                ))}
            </Col>
            <Col xs={12} className="d-flex flex-column" style={{ gap: '8px', paddingLeft: '6px' }}>
              <h3 className="document-category m-0">
                I più consultati
              </h3>
              {repConsultati.map((report, index) => (
                <DownloadDocument
                  disabled={report.rule_showhide !== 'ABILITATO'}
                  key={report.id_funzione}
                  title={report.titolo_report}
                  periodoString={report.periodo_dati}
                  descrizione={report.descrizione_report}
                  idFunzione={report.id_funzione}
                  pData={report.pdata}
                  metadati={report}
                  level={3}
                  tabIndex={0}
                  urlPath="piu-consultati"
                />
              ))}
            </Col>
          </Row>
        </main>
      </div>
    </>
  );
};

export default Home;
